import React from "react";

function MainHeaderUnderline() {
  return (
    <svg
    className='h1_line'
    xmlns="http://www.w3.org/2000/svg"
    width="117"
    height="1"
    fill="none"
    viewBox="0 0 117 1"
  >
    <path stroke="url(#paint0_linear_35_988)" d="M0 0.5L117 0.5"></path>
    <defs>
      <linearGradient
        id="paint0_linear_35_988"
        x1="-0.325"
        x2="117.101"
        y1="1"
        y2="1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0767F4"></stop>
        <stop offset="1" stopColor="#2AC3D1"></stop>
      </linearGradient>
    </defs>
  </svg>
  );
}

export default MainHeaderUnderline;